import React from 'react';
import {ColorPicker, Modal} from 'polyphony/components/generic';

const styles = {
    editor: {
        overflow: 'auto', backgroundColor: 'white', padding: 30
    },
    nonEditor: {
        height: '100%', overflowY: 'auto'
    }
};

const ModalButton = ({gutenberg:{isEditor, setProp}, children, color, text}) => {
    let editControls = null;
    if (isEditor) {
        const { InspectorControls } = window.wp.editor;
        const { TextControl } = window.wp.components;
        editControls =
          <InspectorControls>
              <TextControl
                  label="Button Text"
                  value={text}
                  onChange={v => setProp('text', v)} />
              <div>
                  <h2>Text Color</h2>
                  <ColorPicker
                      color={color}
                      onChange={v => setProp('color', v)} />
              </div>
          </InspectorControls>;
    }

    return (
        <>
            {editControls}
            <Modal opener={text || "Open Me"} isEditor={isEditor}>
                <div style={isEditor ? styles.editor : styles.nonEditor}>
                    {children}
                </div>
            </Modal>
        </>
    );
};

ModalButton.title = "Modal";
ModalButton.slug = "modal";
ModalButton.category = "layout";
ModalButton.icon = "wordpress";

polyphony.addBlock(ModalButton);

